import firebase from "firebase/app";
import "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCBVcVz4e8liFN7kny3nGmTM-ZQdA9cPvw",
  authDomain: "b-2021.firebaseapp.com",
  databaseURL: "https://b-2021-default-rtdb.firebaseio.com",
  projectId: "b-2021",
  storageBucket: "b-2021.appspot.com",
  messagingSenderId: "349651739399",
  appId: "1:349651739399:web:61f1e15d9a315fddee9ba2",
};

firebase.initializeApp(firebaseConfig);

export { firebase };
